import React, { createContext, useState, useContext, useMemo } from 'react';
import PosterModal1 from './modals/PosterModal1';
import PosterModal2 from './modals/PosterModal2';
import PosterModal3 from './modals/PosterModal3';
import PosterModal4 from './modals/PosterModal4';
import PosterModal5 from './modals/PosterModal5';
import PosterModal6 from './modals/PosterModal6';
import PosterModal7 from './modals/PosterModal7';
import PosterModal8 from './modals/PosterModal8';
import DoorModal from './modals/DoorModal';
import useSWR from 'swr';
import { getVoteStatus, getPtp } from 'src/api';
import { useUser } from 'src/context';

const PosterContext = createContext();

export const usePoster = () => useContext(PosterContext);

export const PosterProvider = ({ children }) => {
  const [activeModal, setActiveModal] = useState(null);
  const [isDoorModalOpen, setIsDoorModalOpen] = useState(false);

  const { isLogin } = useUser();

  const { data: voteStatus } = useSWR(`goty2024-voteStatus`, getVoteStatus);

  const { data: ptpData } = useSWR(isLogin ? `goty2024-ptp` : null, getPtp);

  const ptpStep = ptpData?.data?.step || 0;
  const isOpening = voteStatus?.data?.event === "OPEN_SECOND";

  const openPosterModal = (id) => {
    setActiveModal(id);
  };

  const closePosterModal = () => {
    setActiveModal(null);
  };

  const openDoorModal = () => {
    setIsDoorModalOpen(true);
  };

  const closeDoorModal = () => {
    setIsDoorModalOpen(false);
  };

  const modals = [
    PosterModal1, PosterModal2, PosterModal3, PosterModal4,
    PosterModal5, PosterModal6, PosterModal7, PosterModal8
  ];

  const isGameEnabled = useMemo(() => {
    const now = new Date();
    const currentHour = now.getHours();

    return isOpening && ptpStep >= 3 && (currentHour >= 20 || currentHour < 4);
  }, [ptpStep, isOpening]);

  return (
    <PosterContext.Provider value={{ openPosterModal, openDoorModal, isGameEnabled }}>
      {children}
      {modals.map((ModalComponent, index) => (
        <ModalComponent
          key={index}
          isOpen={activeModal === index + 1}
          onClose={closePosterModal}
        />
      ))}
      <DoorModal
        isOpen={isDoorModalOpen}
        onClose={closeDoorModal}
      />
    </PosterContext.Provider>
  );
};
